import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PopWrapper from '@remote/components/PopWrapper.vue'
import DeviceList from '@remote/components/DeviceList'
import { usePromisifyDialog } from '@shared/utils/dialog'


export default /*#__PURE__*/_defineComponent({
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {



const {isShow, close } = usePromisifyDialog(emit)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopWrapper, {
    close: _unref(close),
    "is-show": _unref(isShow),
    style: {zIndex: 9}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(DeviceList), {
          close: _unref(close),
          class: "pop-wrapper-device-list"
        }, null, 8, ["close"])
      ])
    ]),
    _: 1
  }, 8, ["close", "is-show"]))
}
}

})